import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../FormGroup';
import FormActions from '../FormActions';
import { ensureAllValid } from '../../utils';

export default function CampusForm({
  action,
  state,
  isUnique,
  isDisabled,
  isValid,
  updateValue,
  send,
  cancel,
}) {
  return (
    <form className="create" id="create-campus-form">
      <FormGroup
        isUnique={isUnique}
        isValid={isValid.name}
        setFocus
        label="Name"
        name="name"
        state={state.name}
        update={updateValue}
        setRequired
      />
      <FormGroup
        isValid={isValid.street_address}
        label="Street"
        name="street_address"
        state={state.street_address}
        update={updateValue}
        setRequired
      />
      <FormGroup
        isValid={isValid.city}
        label="City"
        name="city"
        state={state.city}
        update={updateValue}
        setRequired
      />
      <FormGroup
        isValid={isValid.state}
        label="State"
        name="state"
        state={state.state}
        update={updateValue}
        setRequired
      />
      <FormGroup
        isValid={isValid.zip}
        label="Zip"
        name="zip"
        state={state.zip}
        update={updateValue}
        setRequired
      />
      <FormActions
        action={action}
        send={send}
        disableSend={isDisabled || !ensureAllValid(isValid)}
        cancel={cancel}
        type="campus"
      />
    </form>
  );
}

CampusForm.propTypes = {
  action: PropTypes.string.isRequired,
  state: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isUnique: PropTypes.bool.isRequired,
  isValid: PropTypes.array.isRequired,
  updateValue: PropTypes.func.isRequired,
  send: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};
